<template>
  <div class="single-code-analysis-chart-container" :id="chartid"></div>
</template>

<script>
export default {
  name: 'ScatterChart',
  props: {
    chartid: String,
    charttitle: String,
    xtitle: String,
    ytitle: String,
    tooltip1: String,
    tooltip2: String,
    tooltip3: String,
    chartdata: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.$nextTick(() => {
      this.drawShareGrowthRate(this.chartdata)
    });
  },
  computed: {
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.drawShareGrowthRate(this.chartdata)
      });
    },
  },
  mounted(){
    this.drawShareGrowthRate(this.chartdata);
  },
  methods: {
    drawShareGrowthRate: function(chartdata){
      let that = this
      let myBarChart = that.echarts.init(document.getElementById(that.chartid));
      myBarChart.clear()
      myBarChart.setOption({
        grid: {
          left: 120,
          right: 30
        },
        tooltip: {
          padding: 0,
          backgroundColor: 'rgba(50,50,50,0)',
          borderColor: 'rgba(50,50,50,0)',
          borderWidth: 0,
          formatter: function (obj) {
            return '<div style="padding:10px; min-width:200px; border-radius: 20px; background-color: rgba(50,50,50,0.8);">'
              + '<h2 style="font-size:16px; font-weight:normal; padding-bottom:10px; text-align: left;">' + obj.data[2] + '</h2>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip1 + '<span style="float:right;">'+ that.millonFormat(obj.data[0]) +'%</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip2 + '<span style="float:right;">'+ that.millonFormat(obj.data[1]) + ' ' + obj.data[6] + '</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip3 + '<span style="float:right;">'+ that.millonFormat(obj.data[7]) + ' ' + obj.data[6] + '</span></h3>'
              + '</div>'
              + '<div style="margin:auto; width: 0; height: 0; border-left: 20px solid transparent; border-right: 20px solid transparent; border-top: 20px solid rgba(50,50,50,0.8);"></div>'
          },
          position: function (point) {
            return [point[0] - 100, point[1] - 190]
          }
          // formatter: function (obj) {
          //   var value = obj.value;
          //   return '<div style="font-size:12px; color: #ffffff;">'
          //     + value[2]
          //     + '</div>'
          // }
        },
        xAxis: {
          name: this.xtitle,
          nameLocation: 'middle',
          nameGap: '30',
          axisLine: { 
            show: true,
            lineStyle: {
              color: '#8697ab',
            },
            onZero: false
          },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: '#3e4b5c'
            }
          },
          axisLabel: {
            formatter: function(value){
              return value + '%'
            }
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          name: this.ytitle,
          nameLocation: 'middle',
          nameGap: '100',
          nameRotate: '90',
          axisLine: { 
            show: true,
            lineStyle: {
              color: '#8697ab',
            },
            onZero: false
          },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: '#3e4b5c'
            }
          },
          axisTick: {
            show: false
          },
          scale: true
        },
        series: [{
          data: chartdata,
          type: 'scatter',
          symbolSize: function (data) {
            return Math.sqrt(data[3]) * 6
          },
          label: {
            show: true,
            position: 'right',
            formatter: function (param) {
              return param.data[2]
            },
            color: '#FFFFFF'
          },
          // emphasis: {
          //   label: {
          //     show: false,
          //     formatter: function (param) {
          //       return param.data[2]
          //     },
          //     position: 'top'
          //   }
          // },
          itemStyle: {
            normal: {
              color: function(e){
                if(e.data[5] === '美洲' 
                || e.data[5] === '北美洲' 
                || e.data[5] === 'Americas' 
                || e.data[5] === 'North America'
                || e.data[5] === '南美洲'
                || e.data[5] === 'South America'){
                  return 'rgb(51, 102, 153)'
                }
                if(e.data[5] === '欧洲' || e.data[5] === 'Europe'){
                  return 'rgb(190, 69, 116)'
                }
                if(e.data[5] === '亚洲' || e.data[5] === 'Asia'){
                  return 'rgb(240, 192, 90)'
                }
                if(e.data[5] === '非洲' || e.data[5] === 'Africa'){
                  return 'rgb(150, 79, 76)'
                }
                if(e.data[5] === '大洋洲' || e.data[5] === 'Oceania'){
                  return 'rgb(0, 148, 115)'
                }
                if(e.data[5] === '其他' || e.data[5] === 'Others' || e.data[5] === undefined || e.data[5] === null || e.data[5] === ''){
                  return 'rgb(132, 151, 176)'
                }
                if(e.data[5] === '拉丁美洲和加勒比' || e.data[5] === 'Latin America & Caribbean'){
                  return 'rgb(64, 158, 225)'
                }
              }
            }
          }
        }]
      })

      $(window).resize(function () {
        myBarChart.resize();
      })

    },

    /**
     * next function
     */

  },

}
</script>